module.exports = __webpack_public_path__ + "img/SantaMaria_en.033d8b05.png";